<template>
  <div class="live_detail_container">
    <div class="live_box">
      <div class="player_box">
        <div class="player" v-if="!!liveInfo">
          <!-- videojs视频直播播放 -->
          <video-player v-if="showVideo" :options="videoOptions" />
          <img :src="imgUrl" alt="" v-else />
        </div>
        <div class="partNum" v-if="isShowPartNum">
          <Icon iconClass="users" /><span class="num" v-text="partCount"></span>
        </div>
      </div>
      <div class="live_info_container">
        <van-tabs v-model="active" :line-width="60" class="live_tab_list" v-if="!!liveInfo">
          <van-tab v-for="tab in tabPages" :key="tab.category" :title="!!tab.label ? tab.label : tab.name">
            <!-- 直播介绍 -->
            <detail :detail="liveInfo" v-if="tab.category == 'live'"></detail>
            <!-- 评论跟帖 -->
            <comment :params="commentParams" @replyForm="showCommentReplayForm" v-else-if="tab.category == 'comment'" />
            <!-- 图文互动 -->
            <interactive :liveRoomId="detailParams.liveroomId" v-else-if="tab.category == 'tw'"></interactive>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <!-- 底部操作 -->
    <operate :params="detailParams" :id="liveInfo.id" :contentTitle="liveInfo.title" v-if="!!liveInfo" @showCommentForm="showCommentForm"></operate>
    <!-- 发布评论 -->
    <submit-comment v-if="!!liveInfo" :show="isShowCommentForm" :id="liveInfo.id" :type="liveInfo.contentType" :parentId="commentParentId" :title="liveInfo.title" @showCommentForm="showCommentForm"></submit-comment>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { loadStat, clickPlayCount, addScore } from "@/utils";
import liveApi from "@/api/apis/live.js";
import commApi from "@/api/apis/common.js";
import VideoPlayer from "./components/VideoPlayer"; // 直播
import detail from "./components/Detail"; // 详情
import interactive from "./components/Interactive"; // 图文互动
import comment from "./components/Comment"; // 评论
import operate from "./components/Operate"; // 底部
import { qtSendPV } from "@/utils/qt.js";
import submitComment from "./components/SubmitComment"; //发表评论
export default {
  name: "LiveDetail",
  computed: {
    ...mapState("app", ["userInfo", "nodeCode"]),
  },
  data() {
    return {
      /* 是否显示评论表单 */
      isShowCommentForm: false,
      commentParentId: "0",
      /* 获取详情所需的参数 */
      detailParams: {
        contentType: null,
        liveroomId: null,
        cId: null,
        fromFlag: null,
      },
      /* 获取评论列表的参数 */
      commentParams: {
        contentId: null,
        type: null,
      },
      liveInfo: null, // 直播详情
      partCount: 0, // 参与人数
      isShowPartNum: false, // 是否显示参与人数
      imgUrl: null, //封面图
      showVideo: false, //是否显示视频
      liveStatus: 0, // 直播状态 0：草稿  1：未开始，2：进行中，3：已结束
      tabPages: [], //直播介绍、评论跟帖、图文互动
      active: 0, //默认显示第0个tab项
      /* videojs初始化参数 */
      videoOptions: {
        autoplay: true, //自动播放
        controls: true, //用户可以与之交互的控件
        loop: true, //视频一结束就重新开始
        muted: false, //默认情况下将使所有音频静音
        preload: "auto",
        aspectRatio: "16:9", //显示比率
        language: "zh-CN", // 设置语言
        fullscreen: {
          options: { navigationUI: "hide" },
        },
        sources: [],
      },
      shareUrl: "",
      terminateTimePicker: false,//终止定时器
    };
  },
  components: {
    VideoPlayer,
    detail,
    interactive,
    comment,
    operate,
    submitComment,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == "/index_share") {
        vm.shareUrl = location.href.replace("/live_detail?", "/index_share?");
      } else {
        vm.shareUrl = location.href;
      }
    });
  },
  methods: {
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;

      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: _this.shareUrl
      }).then((res) => {
        let desc = "";
        if (!!_this.liveInfo.description && _this.liveInfo.description.length > 0) {
          desc = _this.liveInfo.description;
        } 
        desc = desc.replace(/\r\n/g, "").replace("\n", "").replace(/(^\s*)|(\s*$)/g, "");
        _this.$WeiXin.shareWeiXin(res, _this.liveInfo.title + " - 法治号客户端", desc, _this.shareUrl, _this.liveInfo.sharePictureUrl);
      }).catch((err) => {

      });
    },
    /* 获取直播详情 */
    getLiveRoomInfoById() {
      var _this = this;
      liveApi
        .getLiveRoomInfoById(_this.detailParams)
        .then((res) => {
          if (res.suc == 1) {
            document.title = res.data.title;
            _this.liveInfo = res.data;
            _this.wechatShare(); // 微信二次分享
            _this.statistics(); // 统计
            // _this.trackHomePage(); // QT 首页浏览埋点
            _this.addScore(); // 增加积分
            _this.partCount = res.data.partCount;
            _this.isShowPartNum = res.data.isShowPartNum;
            _this.tabPages = res.data.tabPages;

            _this.commentParams.contentId = _this.liveInfo.id;
            _this.commentParams.type = _this.liveInfo.contentType || 4;

            let playUrl = null;
            var type = null;

            // 0：草稿  1：未开始，2：进行中，3：已结束
            var startTime = new Date(_this.liveInfo.startTime.replace(/-/g, '/')).getTime(); // 直播开始时间
            var curTime = new Date().getTime(); // 当前时间
            var endTime = null; // 直播结束时间
            if (!!_this.liveInfo.endTime && _this.liveInfo.endTime.length > 0) { //设置了结束时间
              endTime = new Date(_this.liveInfo.endTime.replace(/-/g, '/')).getTime();
              if (curTime >= endTime || _this.liveInfo.status == 3) {
                _this.liveStatus = 3; // 直播结束
                if (!!_this.liveInfo.replayUrl && _this.liveInfo.replayUrl.length > 0) {
                  _this.showVideo = true;
                  playUrl = _this.liveInfo.replayUrl;
                } else {
                  _this.showVideo = false;
                }
              } else if (curTime >= startTime) {
                _this.liveStatus = 2; // 直播中
                if (!!_this.liveInfo.playUrl && _this.liveInfo.playUrl.length > 0) {
                  _this.showVideo = true;
                  playUrl = _this.liveInfo.playUrl;
                } else {
                  _this.showVideo = false;
                }

                /* 目前没有自动结束的功能，客户端接口中没有结束时间的字段 */
                // 定时器，需要重新调用接口获取直播状态 —— 后台中手动控制直播结束
                // 。。。
                // 或者，随着时间推移来控制直播结束
                // 。。。

              } else {
                _this.liveStatus = 1; // 未开始
                _this.showVideo = false;
                // 定时器，随着时间推移来控制直播开始，进入直播状态
                _this.startLiveHandler();
              }
            } else { // 未设置结束时间
              if (curTime >= startTime && _this.liveInfo.status == 3) {
                _this.liveStatus = 3; // 直播结束
                if (!!_this.liveInfo.replayUrl && _this.liveInfo.replayUrl.length > 0) {
                  _this.showVideo = true;
                  playUrl = _this.liveInfo.replayUrl;
                } else {
                  _this.showVideo = false;
                }
              } else if (curTime >= startTime) {
                _this.liveStatus = 2; // 直播中
                if (!!_this.liveInfo.playUrl && _this.liveInfo.playUrl.length > 0) {
                  _this.showVideo = true;
                  playUrl = _this.liveInfo.playUrl;
                } else {
                  _this.showVideo = false;
                }

                /* 目前没有自动结束的功能，客户端接口中没有结束时间的字段 */
                // 定时器，需要重新调用接口获取直播状态 —— 后台中手动控制直播结束
                // 。。。

              } else {
                _this.liveStatus = 1; // 未开始
                // 定时器，随着时间推移来控制直播开始，进入直播状态
                _this.startLiveHandler();
              }
            }

            if (!!playUrl && playUrl.length > 0) {
              if (playUrl.indexOf(".m3u8") > -1) {
                type = "application/x-mpegURL";
              } else if (playUrl.indexOf(".mp4") > -1) {
                type = "video/mp4";
              }
            }

            _this.imgUrl = !!_this.liveInfo.imgUrl ? _this.liveInfo.imgUrl : require("@/assets/images/default_pic_16_9.png");
            _this.videoOptions.poster=_this.liveInfo.imgUrl
            _this.videoOptions.sources = [{
              src: playUrl,
              type: type,
            }];
            // _this.getOnAirLiveRoomPartData(); // 获取直播间参与人数
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 获取直播间参与人数 */
    getOnAirLiveRoomPartData() {
      var _this = this;
      liveApi
        .getOnAirLiveRoomPartData({ id: _this.detailParams.liveroomId })
        .then((res) => {
          if (res.suc == 1) {
            _this.isShowPartNum = res.data.isShowPartNum;
            _this.partCount = res.data.participantsNumber;
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
          setTimeout(function () {
            if (!_this.terminateTimePicker) {
              _this.getOnAirLiveRoomPartData();
            }
          }, 3000);
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 直播 未开始 -> 开始进入直播 */
    startLiveHandler() {
      var _this = this;
      setTimeout(function () {

        let playUrl = null;
        var type = null;

        var startTime = new Date(_this.liveInfo.startTime.replace(/-/g, '/')).getTime(); // 直播开始时间
        var curTime = new Date().getTime(); // 当前时间

        console.log(curTime);

        if (curTime >= startTime) {
          _this.liveStatus = 2; // 直播中
          if (!!_this.liveInfo.playUrl && _this.liveInfo.playUrl.length > 0) {
            _this.showVideo = true;
            playUrl = _this.liveInfo.playUrl;
          } else {
            _this.showVideo = false;
          }

          /* 目前没有自动结束的功能，客户端接口中没有结束时间的字段 */
          // 定时器，需要重新调用接口获取直播状态 —— 后台中手动控制直播结束
          // 。。。
          // 或者，随着时间推移来控制直播结束
          // 。。

          if (!!playUrl && playUrl.length > 0) {
            if (playUrl.indexOf(".m3u8") > -1) {
              type = "application/x-mpegURL";
            } else if (playUrl.indexOf(".mp4") > -1) {
              type = "video/mp4";
            }
          }

          _this.videoOptions.sources = [{
            src: playUrl,
            type: type,
          }];

        } else {
          if (!_this.terminateTimePicker) {
            _this.startLiveHandler();
          }
        }
      }, 1000);
    },
    /* 统计 */
    statistics() {
      let tj_params = {
        contentCreationTime: this.liveInfo.contentCreationTime, // 创建时间
        contentId: this.liveInfo.id, // 稿件Id
        contentTitle: this.liveInfo.title,
        contentType: 4,
        memberId: this.liveInfo.editorId, // 当前稿件的编辑者的id
        nickName: this.liveInfo.editor, // 当前稿件的编辑者的用户名称
      };
      if (this.detailParams.fromFlag == 0) {
        tj_params = Object.assign(tj_params, {
          channelId: this.liveInfo.channelId, // 栏目id
          channelName: this.liveInfo.channelName, // 栏目名称
        });
      } else if (this.detailParams.fromFlag == 1) {
        tj_params = Object.assign(tj_params, {
          channelId: this.liveInfo.specialId, // 专题id
          channelName: this.liveInfo.specialName, // 专题名称
        });
      }
      clickPlayCount(tj_params);
    },
    /* QT 首页浏览埋点 */
    trackHomePage() {
      qtSendPV("home_pg", {
        current_page_name: this.liveInfo.specialTitle || "",
        current_page_id: String(this.liveInfo.channelId || ""),
        current_channel_name: this.liveInfo.channelName || "专题",
      });
    },
    /* 增加积分 */
    addScore() {
      let jf_params = {
        code: "zbj", // 必传 (xsgg、fxcg、lnr、tpdcfbcg、gksp、gkyp、zbj、dy、dz、sc)
        description: "直播间", // 必传，积分类型描述 (欣赏广告、分享内容、浏览内容、参与投票、观看视频、观看音频、直播间、订阅、点赞、收藏)
        contentType: this.detailParams.contentType, // 非必传，稿件的type
        contentId: this.detailParams.liveroomId, // 非必传，稿件的id
        contentName: this.liveInfo.title, // 非必传，稿件的标题
      }
      if (!!this.userInfo) {
        jf_params = Object.assign(jf_params, {
          memberId: this.userInfo.id, //会员id
        });
      }
      addScore(jf_params);
    },
    /* 显示或隐藏评论表单 */
    showCommentForm(data) {
      this.isShowCommentForm = data;
      this.commentParentId = "0";
    },
    /* 评论回复,显示评论表单 */
    showCommentReplayForm(data) {
      this.isShowCommentForm = true;
      this.commentParentId = data;
    },
  },
  created() {
    // this.$emit('open-app-event');
    let query = this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "id")) {
      this.detailParams.contentType = Number(query.contentType) || 4;
      this.detailParams.liveroomId = Number(query.id);
      this.detailParams.fromFlag = Number(query.fromFlag) || 0;
      this.detailParams.cId = Number(query.cId) || 0;
      if (!!this.userInfo) {
        this.detailParams.memberId = this.userInfo.id;
      }
      this.getLiveRoomInfoById(); //获取直播间详情
      loadStat(); // 友盟统计
    } else if (Object.prototype.hasOwnProperty.call(query, "contentId")) {
      this.detailParams.contentType = Number(query.contentType) || 4;
      this.detailParams.liveroomId = Number(query.contentId);
      this.detailParams.fromFlag = Number(query.fromFlag) || 0;
      this.detailParams.cId = Number(query.cId) || 0;
      if (!!this.userInfo) {
        this.detailParams.memberId = this.userInfo.id;
      }
      this.getLiveRoomInfoById(); //获取直播间详情
      loadStat(); // 友盟统计
    } else {
      this.$router.replace({
        path: "/error",
      });
    }
  },
  destroyed() {
    this.terminateTimePicker = true;
  }
};
</script>
<style scoped lang="scss">
.live_detail_container {
  width: 100%;
  height: 100%;
  padding: 0px 0px 40px;
  overflow-x: hidden;
  overflow-y: auto;
  .live_box {
    width: 100%;
    height: 100%;
    padding: 0;
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    .player_box {
      position: relative;
      width: 100%;
      height: 0;
      padding-bottom: 56.25%;
      background-color: #000;
      overflow: hidden;
      .player {
        position: absolute;
        left: 0;
        top: 0;
        display: block;
        width: 100%;
        height: 100%;
        overflow: hidden;
        display: flex;
        justify-content: center;
        img {
          object-fit: contain;
          max-width: 100%;
          max-height: 100%;
        }
      }
      .partNum {
        position: absolute;
        z-index: 10;
        right: 2px;
        bottom: 30px;
        padding: 2px 5px;
        background: rgba(0, 0, 0, 0.2);
        border-radius: 5px;
        color: #fff;
        .tj-svg-icon {
          vertical-align: -0.2em;
          margin-right: 3px;
        }
        .num {
          color: #fff;
          font-size: 12px;
          font-family: Microsoft YaHei, 微软雅黑, Arial, Helvetica,
            sans-serif;
        }
      }
    }
    .live_info_container {
      flex: 1;
      overflow-x: hidden;
      overflow-y: auto;
      .live_tab_list {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        /deep/.van-tabs__wrap {
          border-top: 1px solid #dadada;
          border-bottom: 1px solid #dadada;
          .van-tabs__nav {
            background-color: #f0f0f0;
          }
        }
        /deep/.van-tabs__content {
          flex: 1;
          overflow: hidden;
          .van-tab__pane {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>